import { AlertCircle } from 'lucide-react'

interface ErrorsCardProps {
    errorMessages: string[]
}

export default function ErrorsCard({ errorMessages }: ErrorsCardProps) {
    if (!errorMessages || errorMessages.length === 0) return null

    return (
        <div className="bg-white overflow-hidden shadow rounded-lg">
            <div className="px-6 py-4 border-b border-gray-200">
                <h3 className="text-lg leading-6 font-medium text-gray-900 flex items-center">
                    <AlertCircle className="h-5 w-5 text-red-400 mr-2"/>
                    Errors ({errorMessages.length})
                </h3>
            </div>
            <div className="p-6">
                <div className="space-y-3">
                    {errorMessages.map((error, index) => (
                        <div key={index} className="bg-red-50 border border-red-200 rounded-md p-3">
                            <p className="text-sm text-red-700">{error}</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}